// extracted by mini-css-extract-plugin
export var actionButton = "_fz-0";
export var fileInput = "_fz-2";
export var paperclip = "_fz-1";